import React from "react";
import style from "./ActionBar.module.css";
import { formatMoney } from "accounting-js";
import QuantityInput from "./QuantityInput";
import { Button, FormControl, InputGroup } from "react-bootstrap";

export default function ActionBar({
  name,
  price,
  canAddToCart,
  handleAddToQuote,
  isUpdate,
  qty,
  setQty
}) {
  return (
    <div className={style.root}>
      <div className={style.inner}>
        <span className={style.config}>Configure {name}</span>

        <span className={style.price}>{formatMoney(price)}</span>

        <InputGroup className={style.inputGroup}>
          <FormControl
            as={QuantityInput}
            type="number"
            value={qty}
            onConfirm={e => setQty(e.target.value)}
          />

          <InputGroup.Append>
            <Button
              title="Add to Quote"
              onClick={handleAddToQuote}
              disabled={!canAddToCart}
            >
              {isUpdate ? "Update Quote" : "Add to Quote"}
            </Button>
          </InputGroup.Append>
        </InputGroup>
      </div>
    </div>
  );
}
